var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyHole = function SvgKeyHole(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "KeyHole_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h15v15H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#KeyHole_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 7.5,
    x: 1.875,
    y: 6.25,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 7.5,
    x: 1.875,
    y: 6.25,
    stroke: "#24961B",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#24961B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.37 6.25V4.37q0-.615.24-1.2c.16-.38.38-.72.68-1.01.29-.29.63-.52 1.01-.68s.78-.23 1.2-.23a3.04 3.04 0 0 1 2.2.91c.3.29.52.63.68 1.01q.24.585.24 1.2v1.88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10,
    r: 0.938,
    stroke: "#FFF",
    strokeWidth: 2
  }))));
};
export default SvgKeyHole;